



































import { Component, Mixins } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";

import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert/BaseAlert.vue";
import VideoPlayer from "@/components/GrammarToGo/VideoPlayer.vue";

import RequestState from "@/utils/mixins/RequestState";
import { Action, State } from "vuex-class";
import { IVuexState } from "@/models/interfaces/store";
import { IKnowledgeBaseDetail } from "@/models/interfaces/knowledge-base";
import { KnowledgeBaseTypes } from "@/models/enums/knowledge-base";

@Component({
  components: {
    AppContent,
    AppHeaderBackWithTitle,
    AppHeader,
    VideoPlayer,

    BaseSpinner,
    BaseAlert
  },
  mixins: [RequestState]
})
export default class KnowledgeBase extends Mixins(RequestState) {
  @State("knowledgeBaseDetail", { namespace: "knowledgeBase" })
  private knowledgeBaseDetail!: IVuexState<IKnowledgeBaseDetail>;

  @Action("knowledgeBase/fetchKnowledgeBaseDetail")
  private fetchKnowledgeBaseDetail!: (id: string) => any;

  private types = KnowledgeBaseTypes;

  public async mounted() {
    await this.fetchKnowledgeBaseDetail(this.$route.params.id);

    if (this.knowledgeBaseDetail.data?.type === KnowledgeBaseTypes.pdf) {
      window.open(this.knowledgeBaseDetail.data?.fileLocation);
      this.$router.push("/knowledge-base");
    } else {
      const a = document.createElement("a");
      a.href = this.knowledgeBaseDetail.data?.fileLocation ?? "";
      a.download = this.knowledgeBaseDetail.data?.fileLocation ?? "";
      a.click();

      setTimeout(
        route => {
          route.push("/knowledge-base");
        },
        500,
        this.$router
      );
    }
  }
}
